class TodoController {
    constructor() {
        console.log("Controller created");
        this.model = new TodoList();
        document.querySelector("#addBtn").addEventListener("click", this.addTodo.bind(this));
        document.querySelector("#consoleBtn").addEventListener("click", this.log.bind(this));
        document.querySelector("#cleanBtn").addEventListener("click", this.cleanup.bind(this));
    }

    cleanup() {
        this.model.cleanUp();
        this.refreshView();
    }

    log() {
        this.model.log();
    }

    addTodo() {
        let newTodo = document.querySelector("#todoInput");
        if (newTodo.value !== "") {
            this.model.addTodo(newTodo.value.trim());
            this.refreshView();
        }
        newTodo.value = "";
    }

    refreshView() {
        let content = '';
        this.model.getList().forEach((el)=> {
            content += "<tr>" +
                "<td>" + el.title + "</td>" +
                "<td><input type='checkbox'/></td>" +
                "</tr>";
        });
        document.querySelector("#todos").innerHTML = content;
        let todoArray = Array.from(document.querySelectorAll("#todos input[type='checkbox']"));
        todoArray.forEach((el, i) => {
            el.addEventListener("click", this.setDone.bind(this, el, i));
        });
    }

    setDone(el, i) {
        console.log(el.checked)
        this.model.setDone(i, el.checked);
    }
}